// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProductReport":"eo_a bii_a bii_x bii_j bii_u bii_bc bii_ql bii_vv"};